import createStore from "astrid-helpers/src/createStore";
import { onPages } from "./pages";
export const [getDirection, setDirection, useDirection] = createStore("ltr");
onPages(pages => {
  const counts = {
    ltr: 1,
    rtl: 1
  };
  for (const {
    items
  } of pages) {
    for (const {
      dir
    } of items) {
      if (counts[dir]) {
        counts[dir]++;
      }
    }
  }
  console.log(counts);
  setDirection(counts.rtl > counts.ltr ? "rtl" : "ltr");
});
//# sourceMappingURL=direction.js.map